module.exports = __webpack_public_path__ + "img/wild.a41f1536.png";